import { usePopup } from '@contexts/popupContext';
import { Loader } from '@shared/designSystem/Loader';
import styles from '@styles/components/Novedades/RemoverColaborador.module.css';
import { useState } from 'react';
import ResultPopup from '@components/General/ResultPopup';

interface ConfirmationPopupProps {
    title: string | JSX.Element;
    message: string | JSX.Element;
    onConfirm: () => Promise<void>;
    onSuccess?: () => void;
    successMessage?: string;
    errorMessage?: string;
    confirmButtonText?: string;
    cancelButtonText?: string;
}

const ConfirmationPopup = ({
    title,
    message,
    onConfirm,
    onSuccess,
    successMessage,
    errorMessage,
    confirmButtonText = 'Confirmar'.localized(),
    cancelButtonText = 'Cancelar'.localized(),
}: ConfirmationPopupProps) => {

    const { hidePopup, showPopup } = usePopup();
    const [loading, setLoading] = useState(false);

    const handleConfirm = async () => {
        setLoading(true);
        try {
            await onConfirm();
            showPopup(() => <ResultPopup result={successMessage} succesful={true} />);
            onSuccess?.();
        } catch (error) {
            showPopup(() => <ResultPopup result={errorMessage} succesful={false} />);
        }
        setLoading(false);
    };

    return (
        <div className={styles['popup']}>
            <div className={styles['title']}>{title}</div>
            <div className={styles['warning-text']}>
                {/* Can handle both string and JSX.Element */}
                {message}
            </div>

            <div className={styles['bottom-container']}>
                <div className={`${styles['button']} ${styles['cancelar']}`} onClick={hidePopup}>
                    {cancelButtonText}
                </div>

                <div
                    className={`${styles['button']} ${styles['agregar']}`}
                    onClick={handleConfirm}>
                    {!loading ? (
                        confirmButtonText
                    ) : (
                        <div className={styles['no-qontact-points']}>
                            <Loader height="32px" width="32px" />
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

type InformationPopupProps = Omit<ConfirmationPopupProps, 'onConfirm' | 'onSuccess' | 'successMessage' | 'errorMessage'> & {
    onOK: () => void;
};

const InformationPopup = ({
    title,
    message,
    onOK,
    confirmButtonText = 'Confirmar'.localized(),
    cancelButtonText = 'Cancelar'.localized(),
}: InformationPopupProps) => {

    const { hidePopup, showPopup } = usePopup();
    const [loading, setLoading] = useState(false);

    const handleOK = async () => {
        onOK();
    };

    return (
        <div className={styles['popup']} style={{ height: 'auto' }}>
            <div className={styles['title']}>{title}</div>
            <div className={styles['warning-text']}>
                {/* Can handle both string and JSX.Element */}
                {message}
            </div>

            <div className={styles['bottom-container']}>
                <div className={`${styles['button']} ${styles['cancelar']}`} onClick={hidePopup}>
                    {cancelButtonText}
                </div>

                <div
                    className={`${styles['button']} ${styles['agregar']}`}
                    onClick={handleOK}>
                    {!loading ? (
                        confirmButtonText
                    ) : (
                        <div className={styles['no-qontact-points']}>
                            <Loader height="32px" width="32px" />
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};




export default ConfirmationPopup;

export { InformationPopup };
